import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

const getMobileOS = () => {
  const userAgent = navigator.userAgent;

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return "iOS";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  return "Unknown";
};

const RollOverRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const os = getMobileOS();

    const openApp = () => {
      const fallbackUrl = "/";
      let appUrl;

      if (os === "iOS") {
        const currentUrl = window.location.href;
        const envMatch = currentUrl.match(/pp-(int|stg)/);
        if (envMatch) {
          const env = envMatch[1];
          appUrl = `parentapp://${env}.parent.campaustralia.com.au/rollover`;
        } else {
          appUrl = "parentapp://parent.campaustralia.com.au/rollover";
        }
      } else if (os === "Android") {
        appUrl = "parentapp://parent.campaustralia.com.au/rollover";
      } else {
        navigate(fallbackUrl);
        return;
      }

      // Start tracking time to determine if the app was successfully opened
      const start = new Date().getTime();

      // Try to open the app directly using the deep link
      window.location.href = appUrl;

      const timeout = setTimeout(() => {
        const end = new Date().getTime();
        if (end - start < 5000) {
          navigate(fallbackUrl);
        }
      }, 5000);

      // Handle focus change (if app opens, the browser should lose focus)
      window.addEventListener("blur", () => clearTimeout(timeout));

      return () => {
        window.removeEventListener("blur", () => clearTimeout(timeout));
      };
    };

    openApp();
  }, [navigate]);

  return <div>Redirecting to the app or fallback page...</div>;
};

export default RollOverRedirect;
